import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ReactComponent as IconPlus } from "../../../../../assets/svg/actions/icn-plus-10px-9px.svg";

// TODO: Make it global

const UploadButton = ({
    icon: Icon = IconPlus,
    variant = "primary",
    label = "Upload",
    showLabel = true,
    inputId,
    onUpload = console.log,
    ...props
}) => {
    inputId = inputId || Math.random(1000);

    const handleChange = (e) => {
        if(e.target.files) {
            const image = {
                source: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0]
            };
            
            onUpload(image);
        }
    }

    // const handleUpload = async (e) => {
    //     e.preventDefault()
    //     const formData = new FormData()
    //     formData.append('image', image.raw)
    //     const config = { headers: { 'content-type': 'multipart/form-data' } }

    //     // await uploadToBackend('endpoint', { image: image.raw }, config)
    // }

    return (
        <div className="upload-button-container">
            <label className="upload-button" htmlFor={`upload-btn-${inputId}`}>
                <span className={classNames("upload-button-icon", props.className, `btn btn-${variant}`)} variant={variant}>
                    <Icon />
                </span>
                {showLabel &&
                    <span className="upload-button-label">{label}</span>}
            </label>
            <input type="file" id={`upload-btn-${inputId}`} style={{ display: 'none' }} onChange={handleChange} />
        </div>
    )
}

UploadButton.propTypes = {
    icon: PropTypes.element,
    label: PropTypes.string,
    variant: PropTypes.string,
}

export default UploadButton
